import { FunctionalComponent, h } from "preact";
import { useEffect } from "preact/hooks";
import style from './style.scss';

interface Props {
    setShow: (value: boolean) => void;
    show: boolean;
}

const Spinner: FunctionalComponent<Props> = (props: Props) => {
    useEffect(() => {
        if (!props.show) {
            setTimeout(() => props.setShow(true), 200)
        }
    })
    if (props.show) {
        return (<div class={style.container} style={{ position: "relative" }}>
            <div class={style.spin} />
        </div>
        )
    }
    return <div />

}

export default Spinner;